import { render, staticRenderFns } from "./QueriesPage.vue?vue&type=template&id=5f474f3e&scoped=true&"
import script from "./QueriesPage.vue?vue&type=script&lang=js&"
export * from "./QueriesPage.vue?vue&type=script&lang=js&"
import style0 from "./QueriesPage.vue?vue&type=style&index=0&id=5f474f3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f474f3e",
  null
  
)

export default component.exports